export default {
  hero: {
    badge: "Propulsé par Otovo",
    tagline: "Location de panneaux solaires",
    headline: {
      before: "Énergie solaire à partir d'un paiement ",
      highlight: "mensuel",
      after: " fixe",
    },
    title: "Le solaire en location pour les particuliers",
    description:
      "Aucun coût initial. Installation, maintenance et garantie incluses.",
    cta: "Obtenir mon devis solaire",
    "monthly-payment": {
      title: "Paiement mensuel",
      price: "XX€/mois",
      subtitle: "Abonnement solaire tout compris",
      noUpfront: "Pas d'avance",
      autoPay: "Paiement auto",
      protected: "Protégé",
    },
  },
  solutions: {
    headline: {
      before: "Une façon plus intelligente de passer à l'énergie ",
      highlight: "solaire",
      after: "",
    },
    subtitle:
      "Tous les avantages de l'énergie solaire sans les obstacles traditionnels.",
    cards: {
      noUpfront: {
        title: "Aucun investissement initial",
        description:
          "Commencez à utiliser l'énergie solaire sans débourser des milliers d'euros dès le départ.",
      },
      fixedPayment: {
        title: "Paiement mensuel fixe",
        description: "Un paiement prévisible chaque mois.",
      },
      allInclusive: {
        title: "Service tout compris",
        description: "Installation, entretien et garantie inclus.",
      },
      optionToBuy: {
        title: "Option d'achat différé",
        description: "Achetez le système après 10 ans.",
      },
    },
  },
  comparison: {
    headline: {
      before: "",
      highlight: "Location",
      after: " ou achat : quelle est la différence ?",
    },
    buyingColumn: "Acheter du solaire",
    leasingColumn: "Location solaire",
    criteria: "Critères",
    rows: {
      upfrontCost: {
        criteria: "Coût initial",
        buying: "Élevé",
        leasing: "Aucun",
      },
      monthlyCost: {
        criteria: "Coût mensuel",
        buying: "Aucun",
        leasing: "Frais mensuels fixes",
      },
      maintenance: {
        criteria: "Maintenance",
        buying: "Votre coût",
        leasing: "Inclus",
      },
      warranty: {
        criteria: "Garantie",
        buying: "Limitée",
        leasing: "Couverture complète",
      },
      flexibility: {
        criteria: "Flexibilité",
        buying: "Faible",
        leasing: "Acheter après 10 ans",
      },
    },
  },
  "how-it-works": {
    title: "Comment ça marche",
    subtitle:
      "Avec le leasing, vous n'avez jamais à vous soucier des coûts imprévus. De l'installation à la maintenance à long terme, tout est pris en charge.",
    steps: {
      requestOffer: {
        title: "Demandez votre offre",
        subtitle: "Parlez-nous de votre maison et de vos besoins énergétiques.",
      },
      getApproved: {
        title: "Obtenir l'approbation",
        subtitle: "Nous vérifions votre admissibilité au crédit-bail.",
      },
      installation: {
        title: "Installation",
        subtitle: "Votre système est installé par des professionnels.",
      },
      startSaving: {
        title: "Commencez à économiser",
        subtitle: "Payez mensuellement et réduisez vos factures d'électricité.",
      },
    },
  },
  "everything-included": {
    title: "Tout est compris",
    today: "Aujourd'hui",
    month: "Mois",
    cards: {
      solarPanels: {
        title: "Panneaux solaires et onduleur",
        subtitle:
          "Équipements haut de gamme provenant des principaux fabricants, offrant les meilleurs rendements énergétiques du secteur.",
      },
      monitoring: {
        title: "Surveillance 24 h/24, 7 j/7",
        subtitle:
          "Suivez les performances de votre système en temps réel grâce à notre plateforme de surveillance avancée.",
        "bullet-1": "Données de performance en direct",
        "bullet-2": "Alertes instantanées",
      },
      energyProduction: {
        title: "Production d'énergie",
        subtitle: "Consultez votre production mensuelle en un coup d'œil.",
      },
      professionalInstallation: {
        title: "Installation professionnelle",
        subtitle:
          "Des techniciens certifiés garantissent un travail de qualité.",
      },
      permits: {
        title: "Permis et formalités administratives",
        subtitle:
          "Nous nous occupons de toute la documentation et des autorisations.",
      },
      maintenance: {
        title: "Entretien et réparations",
        subtitle:
          "Tout l'entretien courant et les réparations imprévues sont couverts pendant toute la durée du bail.",
      },
      warranty: {
        title: "Couverture complète de la garantie",
        subtitle: "Protection complète pour votre système solaire.",
      },
    },
  },
  "flexible-over-time": {
    title: "Flexible dans le temps",
    cards: {
      buyAfter10: {
        title: "Achetez votre système après 10 ans",
        description:
          "Devenez propriétaire de votre système solaire à un prix fixe.",
      },
      transferContract: {
        title: "Contrat de transfert lors de la vente",
        description: "Transmettez le bail au nouveau propriétaire.",
      },
      upgradeLater: {
        title: "Mettez à niveau votre système ultérieurement",
        description: "Ajoutez des piles ou augmentez la capacité.",
      },
    },
  },
  cta: {
    title: "Vérifiez votre éligibilité au solaire",
    subtitle:
      "Obtenez une offre solaire personnalisée en quelques étapes seulement.",
    features: {
      noCreditCheck: "Aucune vérification de solvabilité pour commencer",
      quickProcess: "Processus rapide de 5 minutes",
      noObligation: "Sans obligation",
    },
    cta: "Obtenir mon devis",
  },
  faq: {
    tagline: "Il reste quelque chose ?",
    title: "Toutes vos questions concernant l'énergie solaire",
    "different-question": "Vous avez une autre question ?",
    "read-more-blog": "Pour en savoir plus, consultez notre blog",
    "get-call-back": "Recevoir un appel",
    items: {
      buyLater: {
        question: "Puis-je acheter le système plus tard ?",
        answer:
          "Oui. Vous pouvez acheter le système après 10 ans à un prix fixe. Cela vous donne la possibilité de devenir propriétaire de votre système solaire une fois que vous en avez expérimenté les avantages.",
      },
      sellHouse: {
        question: "Que se passe-t-il si je vends ma maison ?",
        answer:
          "Le contrat peut être transféré au nouveau propriétaire. C'est généralement un argument de vente, car le nouveau propriétaire peut profiter de l'énergie solaire sans aucun investissement initial.",
      },
      somethingBreaks: {
        question: "Que se passe-t-il si quelque chose se casse ?",
        answer:
          "Tous les entretiens et réparations sont inclus dans votre tarif mensuel. Nous nous occupons de tout, de l'entretien régulier aux réparations imprévues, afin que vous n'ayez jamais à vous soucier de coûts supplémentaires.",
      },
      upgradeLater: {
        question: "Puis-je améliorer mon système plus tard ?",
        answer:
          "Oui. Vous pouvez ajouter des équipements tels que des batteries ou augmenter la capacité de votre système. Nous travaillerons avec vous pour garantir que toutes les améliorations correspondent à vos besoins et à votre budget.",
      },
    },
  },
  installer: {
    hero: {
      badge: "Alimenté par Otovo",
      headline: {
        before: "Concluez davantage de ",
        highlight: "contrats solaires",
        after: " grâce au location intégré",
      },
      description:
        "Pour la première fois en France, vous pouvez désormais proposer un abonnement mensuel pour les systèmes solaires directement dans vos offres sans prendre de risque financier.",
      benefits: {
        "no-upfront": "Aucun coût initial",
        "acceptance-rate": "Taux d'acceptation de 90 %",
        "approval-24h": "Approbation en moins de 24 heures",
        "no-bank-loan": "Aucun prêt bancaire requis",
        "no-borrowing-impact": "Aucun impact sur la capacité d'emprunt",
        "fixed-payments": "Paiements mensuels fixes",
      },
      "cta-learn-more": "En savoir plus",
      "cta-book-demo": "Demander votre Démo",
      tagline:
        "Vous installez. Nous finançons. Soyez payé normalement pour chaque chantier.",
      card: {
        title:
          "Proposez à vos clients des abonnements solaires et débloquez jusqu'à",
        stats: {
          "additional-projects": "Chantiers supplémentaires /an",
          "additional-revenue": "Revenus annuels supplémentaires",
          "conversion-uplift": "Augmentation du taux de conversion",
        },
        "installations-per-year": "Installations par an",
        "slider-min": "5",
        "slider-max": "50",
        "customize-projections": "Projections selon votre activité",
        "how-we-calculate": "Comment nous calculons ce chiffre",
        "discover-revenues": "Découvrez comment nous calculons vos revenus",
      },
    },
    "lost-deals": {
      title: "Combien de chantiers sont abandonnés à cause du financement ?",
      subtitle:
        "De nombreux clients résidentiels hésitent à franchir le pas. Non pas parce qu'ils ne veulent pas passer à l'énergie solaire, mais parce que :",
      painPoints: {
        "high-investment": "L'investissement initial est trop élevé",
        "bank-loans-slow": "Les prêts bancaires prennent trop de temps",
        "borrowing-limited": "La capacité d'emprunt est déjà limitée",
        "approval-uncertain": "L'approbation est incertaine",
      },
    },
    benefits: {
      title: "Les avantages de la location pour les installateurs",
      subtitle: "Développez votre activité grâce à un avantage concurrentiel",
      stats: {
        "close-rate": {
          value: "45 %",
          title: "Augmentation moyenne du taux de clôture",
          description:
            "Convertissez davantage de prospects en supprimant l'obstacle que représentent les coûts initiaux.",
        },
        "system-size": {
          value: "2x",
          title: "Taille moyenne du système importante",
          description:
            "Les clients peuvent s'offrir des installations plus importantes grâce à des paiements mensuels.",
        },
        "faster-sales": {
          value: "3x",
          title: "Ventes plus rapides",
          description:
            "Concluez des transactions en quelques jours, sans attendre des mois le financement du client.",
        },
        satisfaction: {
          value: "100 %",
          title: "Satisfaction client",
          description:
            "Associez les grands installateurs à des options de financement professionnelles.",
        },
      },
    },
    "deal-flow": {
      headline: {
        before: "Des contrats ",
        highlight: "perdus",
        after: " aux chantiers ",
        "highlight-2": "conclus",
      },
      subtitle:
        "Découvrez comment proposer des abonnements solaires mensuels peut transformer votre entonnoir de vente sans modifier votre flux de travail.",
      "image-alt":
        "Comparaison du flux de vente : des contrats perdus aux chantiers conclus",
      left: {
        title: "Prêt (financement classique)",
        items: {
          "approval-rate": {
            label: "Taux d'approbation",
            value: "Faible / incertain",
          },
          "approval-delay": {
            label: "Délai d'approbation",
            value: "Des jours à semaines",
          },
          "commercial-friction": {
            label: "Friction commerciale",
            value: "Élevé (banque, paperasse, hésitation)",
          },
          "customer-objections": {
            label: "Objections des clients",
            value: '"Je dois vérifier auprès de ma banque"',
          },
          "debt-impact": {
            label: "Conséquences sur l'endettement des clients",
            value: "Augmente le ratio d'endettement",
          },
          "sales-cycle": {
            label: "Durée du cycle de vente",
            value: "Long et imprévisible",
          },
          "drop-off-rate": {
            label: "Taux de désistement",
            value: "Élevé",
          },
          "offer-attractiveness": {
            label: "Attractivité de l'offre",
            value: "Standard",
          },
          "closing-speed": {
            label: "Vitesse de fermeture",
            value: "Lent",
          },
          "rare-deal": {
            label: "Affaire rare",
            description: "Retards ou annulations de la part du client",
          },
        },
      },
      right: {
        title: "En location",
        items: {
          "approval-rate": {
            label: "Taux d'approbation",
            value: "approuvé à 90 %",
          },
          "approval-delay": {
            label: "Délai d'approbation",
            value: "<24h",
          },
          "commercial-friction": {
            label: "Friction commerciale",
            value: "Faible (vérification simple des conditions d'éligibilité)",
          },
          "customer-objections": {
            label: "Objections des clients",
            value: "Presque aucun",
          },
          "debt-impact": {
            label: "Conséquences sur l'endettement des clients",
            value:
              "Aucune incidence sur l'endettement (considéré comme un loyer)",
          },
          "sales-cycle": {
            label: "Durée du cycle de vente",
            value: "Rapide et maîtrisé",
          },
          "drop-off-rate": {
            label: "Taux de désistement",
            value: "Considérablement réduit",
          },
          "offer-attractiveness": {
            label: "Attractivité de l'offre",
            value:
              "\"€ 0 d'acompte\" = facteur déclencheur d'un taux de conversion élevé",
          },
          "closing-speed": {
            label: "Vitesse de fermeture",
            value: "Clôture le jour même ou le lendemain",
          },
        },
        final: {
          title: "Affaire conclue",
          description: "Le client signe en toute confiance",
        },
      },
    },
    "how-it-works": {
      title: "Comment ça marche",
      subtitle:
        "Avec le contrat de location, vous n'avez jamais à vous soucier des coûts imprévus. De l'installation à la maintenance à long terme, tout est pris en charge.",
      steps: {
        "request-rental": {
          title: "Demander une location",
          subtitle: "Demander l'accès à l'intégration du contrat de location.",
        },
        "get-verified": {
          title: "Faites-vous vérifier",
          subtitle:
            "Nous vérifions votre profil d'installateur et vos références.",
        },
        "offer-leasing": {
          title: "Proposer des contrats de location dans les offres",
          subtitle:
            "Le contrat de location apparaît automatiquement dans vos simulations financières.",
        },
        "close-contracts": {
          title: "Conclure plus de contrats",
          subtitle: "Offrez à vos clients des options de paiement flexibles.",
        },
      },
    },
    "requirements-comparison": {
      left: {
        title: "Configuration requise pour l'installateur",
        items: {
          certification: "Certification",
          "insurance-coverage": "Couverture d'assurance",
          "company-registration": "Enregistrement de la société",
          ursaf: "URSSAF",
          "identity-document": "Pièce d'identité",
          "bank-details": "Coordonnées bancaires",
          "framework-contract-signed": "Signature d'un contrat-cadre",
        },
      },
      right: {
        title: "Exigences du client",
        items: {
          "valid-id": "Pièce d'identité valide",
          "last-3-payslip": "Les 3 derniers bulletins de paie",
          "property-tax-document": "Document relatif à la taxe foncière",
        },
      },
    },
    "partner-requirements": {
      title: "Exigences envers les partenaires",
      requirements: {
        "certified-installer": {
          title: "Installateur certifié",
          description:
            "Certification et licence valides pour l'installation solaire.",
        },
        "insurance-coverage": {
          title: "Couverture d'assurance",
          description:
            "Assurance responsabilité civile et assurance accidents du travail adéquates.",
        },
        "proven-quality": {
          title: "Expérience éprouvée en qualité",
          description: "Historique démontré d'installations réussies.",
        },
        "otovo-access": {
          title: "Accès à la plateforme Otovo",
          description:
            "Vous le faites via l'intégration de notre portail dans votre compte projetsolaire.",
        },
      },
    },
  },
}
